import { UserProvider } from './contexts/userContext';
import App from "./App";

export const MainApp = () => {
    return (
        <UserProvider>
            <App />
        </UserProvider>
    )
}